import requests, { setToken } from "./httpServices";
import { showErrorAlert } from "./AlertService";
const PaymentServices = {
  payNow: async (paymentData) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      console.log(paymentData);
      const response = await requests.post("/payments/pay", paymentData);
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  getPaymentHistory: async () => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get("/payments/order-history");
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  checkPaymentStatus: async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return { needsPayment: false, amount: null };
      }
      setToken(token);
      const response = await requests.get("/payments/status");
      return response;
    } catch (error) {
      // Don't show error alert for payment status check - it's expected to fail if endpoint doesn't exist or no payment needed
      const errorData = error.response?.data;
      const errorMessage = error.message || "";
      const isNetworkError = errorMessage === "Network Error" || error.code === "ERR_NETWORK";
      
      // Check if it's an HTML error page (endpoint doesn't exist)
      if (typeof errorData === "string" && errorData.includes("<!DOCTYPE html>")) {
        // Silently use localStorage fallback - endpoint doesn't exist
        return null;
      }
      
      // For 404 errors, endpoint doesn't exist - silently use localStorage fallback
      if (error.response?.status === 404) {
        return null;
      }
      
      // For network errors (backend down, CORS, etc.), silently use localStorage fallback
      if (isNetworkError) {
        return null;
      }
      
      // Only log unexpected errors (not network errors or 404s)
      if (error.response?.status && error.response.status >= 500) {
        console.warn("Payment status check server error:", error.response.status);
      }
      
      return { needsPayment: false, amount: null };
    }
  },
  previewPayment: async (baseAmount, promoCode, planType, isFromUrl = false) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token");
      }
      setToken(token);
      
      const requestBody = {
        amount: baseAmount,
        reemcode: promoCode || null,
        // "annual" is the current name for the pay-in-full plan. The backend still
        // accepts "lump_sum" and treats it identically, so existing customers are
        // unaffected - this only changes what new checkouts send.
        planType: planType || "annual",
        isFromUrl: isFromUrl,
      };
      
      // Debug logging
      console.log("=== Preview Payment Request Debug ===");
      console.log("Endpoint: /payments/preview");
      console.log("Full URL will be: https://api.angelwatchedu.org/api/payments/preview");
      console.log("Token exists:", !!token);
      console.log("Token length:", token?.length);
      console.log("Request body:", requestBody);
      
      const response = await requests.post("/payments/preview", requestBody);
      
      console.log("Preview response:", response);
      return response;
    } catch (error) {
      // Enhanced error logging
      console.error("=== Preview Payment Error Debug ===");
      console.error("Error:", error);
      console.error("Error response:", error.response);
      console.error("Error status:", error.response?.status);
      console.error("Error data:", error.response?.data);
      console.error("Error URL:", error.config?.url);
      console.error("Full URL:", error.config?.baseURL + error.config?.url);
      
      const errorData = error.response?.data;
      const errorMessage = errorData?.error || error.message || "Failed to calculate preview";
      
      // Handle 404 specifically
      if (error.response?.status === 404) {
        console.warn("Preview endpoint returned 404 - endpoint may not be available yet");
        throw new Error("Preview endpoint not available (404)");
      }
      
      throw new Error(errorMessage);
    }
  },
};

export default PaymentServices;
